import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { AuthService } from "@shared/services/auth/auth.service";

// The authGuard is a route guard that checks if the user is authenticated before allowing access to certain routes.
// If the user is not authenticated, it attempts to refresh the token. If that fails, it redirects to the login page.
export const authGuard: CanActivateFn = async () => {
    const authService: AuthService = inject(AuthService);
    const router: Router = inject(Router);

    if (authService.isLoggedIn()) {
        return true;
    }

    // const email: string | null = sessionStorage.getItem("email");
    // const password: string | null = sessionStorage.getItem("password");

    // if (email && password) {
    //     return await firstValueFrom(authService.login(email, password))
    //         .then(() => {
    //             return true;
    //         })
    //         .catch(() => {
    //             router.navigate(["/login"]);
    //             return false;
    //         });
    // }

    return authService
        .refreshToken()
        .then(() => {
            return true;
        })
        .catch(() => {
            router.navigate(["/login"]);
            return false;
        });
};
